'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('density_requirements', {
      url: '/account/density/density_requirements',
      template: '<density-requirements></density-requirements>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/density/density_requirements/density_requirements.routes.js